// packages/web/src/main.tsx
import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { router } from './router'
import { ThemeProvider } from './context/ThemeContext'
import { AuthProvider } from './context/AuthContext'
import { SiteConfigProvider } from './context/SiteConfigContext'
import { CartProvider } from './context/CartContext'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <SiteConfigProvider>
          <CartProvider>
            <RouterProvider router={router} />
          </CartProvider>
        </SiteConfigProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
)
